import _ from "lodash";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/hooks";
import { selectVenturesListItems } from "../../redux/ventures/selector";
import { ventures } from "../../redux/ventures/action";
import { useNavigate } from "react-router-dom";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from 'swiper/modules';


export default function Parnerview() {

    const dispatch = useAppDispatch();
    const [dbaasProgram, setDBaasProgram] = useState<any[]>([]);
    const venturesItems = useSelector(selectVenturesListItems);
    const image = require('../../assets/img/venture.jpg');
    const [searchTerm, setSearchTerm] = useState<string>("");
    const navigate = useNavigate()
    const [showPrograms, setShowPrograms] = useState(false);


    const PartnerBanner: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_PARTNER_PAGE_BANNER') : null;
    const banner: any = (PartnerBanner && PartnerBanner[0]?.src ? encodeURI(PartnerBanner[0]?.src) : require('../../assets/img/ONESP.png'))

    const PartnerPageWayToEngageHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_PARTNER_PAGE_WAY_TO_ENGAGE') : null;
    const PartnerPagePartnerWithOnex: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_PARTNER_PAGE_PARTNER_WITH_ONEX') : null;
    const venturePageIdeaContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_VENTURE_PAGE_IDEA_CONTENT') : null;


    return (
        <div className="min-h-screen bg-white px-4 py-8">

            {/* Banner Section */}
            <div
                className="relative flex items-center justify-center w-full h-[650px] bg-cover bg-center"
                style={{
                    backgroundImage: `url(${banner})`,
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/20 z-0" />

                {/* Content */}
                <div className="relative z-10 px-6 md:px-16 max-w-3xl text-white text-left">
                    <div className="bg-primary/80 backdrop-blur-sm rounded-3xl shadow-xl p-10 transition-all duration-300 hover:shadow-[0_20px_50px_rgba(8,112,184,0.2)] hover:scale-[1.03]">
                        <h1 className="text-5xl md:text-6xl font-extrabold mb-4 leading-tight">
                            {PartnerBanner && PartnerBanner[0]?.title
                                ? PartnerBanner[0].title
                                : "Join Us in Cultivating"}
                        </h1>

                        <h2 className="text-2xl md:text-3xl font-semibold mb-3">
                            {PartnerBanner && PartnerBanner[0]?.subTitle
                                ? PartnerBanner[0].subTitle
                                : "Innovation & Entrepreneurship"}
                        </h2>

                        <p className="text-lg font-light leading-relaxed mb-6">
                            {PartnerBanner && PartnerBanner[0]?.description
                                ? PartnerBanner[0].description
                                : "At ONEX, we believe that building a sustainable and thriving entrepreneurial ecosystem requires collective effort."}
                        </p>

                        <button className="bg-white text-primary font-semibold px-6 py-3 rounded-full shadow-md hover:bg-gray-100 transition">
                            Get Started
                        </button>
                    </div>
                </div>
            </div>


            <div className="bg-[#fff4f0] py-16 px-4 mt-20">
                <h2 className="text-3xl font-bold text-center mb-12">
                    {PartnerPageWayToEngageHeading && PartnerPageWayToEngageHeading[0]?.title ? (
                        (() => {
                            const titleWords = PartnerPageWayToEngageHeading[0].title.split(' ');
                            const middle = Math.floor(titleWords.length / 2);
                            const firstHalf = titleWords.slice(0, middle).join(' ');
                            const secondHalf = titleWords.slice(middle).join(' ');
                            return (
                                <>
                                    <span className="text-primary">{firstHalf} </span>
                                    <span className="text-black">{secondHalf}</span>
                                </>
                            );
                        })()
                    ) : (
                        <>
                            <span className="text-orange-600">One Service Provider for </span>
                            <span className="text-black">Startups in India</span>
                        </>
                    )}
                    {/* <span className="text-primary">Ways to Engage</span> with <span className="text-black">ONEX</span> */}
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 text-center">

                    {/* Card 1 */}
                    <div className="flex flex-col items-center px-4">
                        <svg width="40" height="40" viewBox="0 0 24 24" className="text-primary" fill="currentColor">
                            <path d="M8 2H4a2 2 0 0 0-2 2v18h2V4h4V2zm12 0h-4v2h4v18h2V4a2 2 0 0 0-2-2zM10 6v16h4V6h-4z" />
                        </svg>
                        <p className="text-sm text-gray-800 mt-4 font-medium">
                            {PartnerPageWayToEngageHeading ? PartnerPageWayToEngageHeading[0]?.subTitle : null}

                            {/* Provide prototyping and testing infrastructure */}
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div className="flex flex-col items-center px-4">
                        <svg width="40" height="40" viewBox="0 0 24 24" className="text-primary" fill="currentColor">
                            <path d="M20 6h-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v2H4a1 1 0 0 0-1 1v2h18V7a1 1 0 0 0-1-1zM8 4h8v2H8V4zM3 20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9H3v9z" />
                        </svg>
                        <p className="text-sm text-gray-800 mt-4 font-medium">
                            {PartnerPageWayToEngageHeading ? PartnerPageWayToEngageHeading[1]?.subTitle : null}

                            {/* Enable supplier and market access */}
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div className="flex flex-col items-center px-4">
                        <svg width="40" height="40" viewBox="0 0 24 24" className="text-primary" fill="currentColor">
                            <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 2c1.103 0 2 .897 2 2h-2a1 1 0 0 0 0 2h2a2 2 0 0 1 0 4h-1v2h1a1 1 0 0 1 0 2h-1v2h-2v-2h-1a1 1 0 0 1 0-2h1v-2h-1a2 2 0 0 1 0-4h1a1 1 0 0 0 0-2h-2c0-1.103.897-2 2-2z" />
                        </svg>
                        <p className="text-sm text-gray-800 mt-4 font-medium">
                            {PartnerPageWayToEngageHeading ? PartnerPageWayToEngageHeading[2]?.subTitle : null}

                            {/* Financially support the centre or specific program tracks */}
                        </p>
                    </div>

                    {/* Card 4 */}
                    <div className="flex flex-col items-center px-4">
                        <svg width="40" height="40" viewBox="0 0 24 24" className="text-primary" fill="currentColor">
                            <path d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4s-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </svg>
                        <p className="text-sm text-gray-800 mt-4 font-medium">
                            {PartnerPageWayToEngageHeading ? PartnerPageWayToEngageHeading[3]?.subTitle : null}

                            {/* Serve as early customers for product validation */}
                        </p>
                    </div>

                    {/* Card 5 */}
                    <div className="flex flex-col items-center px-4">
                        <svg width="40" height="40" viewBox="0 0 24 24" className="text-primary" fill="currentColor">
                            <path d="M12 2L1 7l11 5 9-4.09V17h2V7L12 2zm0 9.5L3.5 7 12 3.5 20.5 7 12 11.5zm-2 2.96L3 11v2l7 3.18v4.32l2-1 .5.23.5-.23 2 1v-4.32L21 13v-2l-7 3.46v3.19l-2-.91-2 .91v-3.19z" />
                        </svg>
                        <p className="text-sm text-gray-800 mt-4 font-medium">
                            {PartnerPageWayToEngageHeading ? PartnerPageWayToEngageHeading[4]?.subTitle : null}

                            {/* Serve as mentors */}
                        </p>
                    </div>

                </div>
            </div>

            <div className="w-full bg-[#fff4f0] py-16 px-6 mt-20">
                <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start gap-10">

                    {/* Left Side Content */}
                    <div className="w-full lg:w-2/3">
                        <h2 className="text-3xl font-bold mb-10">
                            {PartnerPagePartnerWithOnex && PartnerPagePartnerWithOnex[0]?.title ? (
                                (() => {
                                    const titleWords = PartnerPagePartnerWithOnex[0].title.split(' ');
                                    const middle = Math.floor(titleWords.length / 2);
                                    const firstHalf = titleWords.slice(0, middle).join(' ');
                                    const secondHalf = titleWords.slice(middle).join(' ');
                                    return (
                                        <>
                                            <span className="text-black">{firstHalf} </span>
                                            <span className="text-primary">{secondHalf}</span>
                                        </>
                                    );
                                })()
                            ) : (
                                <>
                                    <span className="text-orange-600">Why Partner with  </span>
                                    <span className="text-black">ONEX</span>
                                </>
                            )}
                            {/* Why <span className="text-[#f15a29]">Partner with ONEX?</span> */}
                        </h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {/* Box 1 */}
                            <div className="bg-primary text-white p-6 rounded shadow-md">
                                <h4 className="text-lg font-semibold mb-2">
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[0]?.subTitle : null}
                                    {/* Impactful Collaborations: */}
                                </h4>
                                <p>
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[0]?.description : null}
                                    {/* Work with one of India’s leading entrepreneurial ecosystems to drive meaningful change. */}
                                </p>
                            </div>

                            {/* Box 2 */}
                            <div className="bg-secondary text-white p-6 rounded shadow-md">
                                <h4 className="text-lg font-semibold mb-2">
                                    {/* Tailored Engagement: */}
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[1]?.subTitle : null}
                                </h4>
                                <p>
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[1]?.description : null}
                                    {/* Align our programs with your CSR goals, innovation strategies, and industry needs. */}
                                </p>
                            </div>

                            {/* Box 3 */}
                            <div className="bg-secondary text-white p-6 rounded shadow-md">
                                <h4 className="text-lg font-semibold mb-2">
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[2]?.subTitle : null}
                                    {/* Nationwide Influence */}
                                </h4>
                                <p>
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[2]?.description : null}
                                    {/* Be part of a national movement supporting founders across sectors. */}
                                </p>
                            </div>

                            {/* Box 4 */}
                            <div className="bg-primary text-white p-6 rounded shadow-md">
                                <h4 className="text-lg font-semibold mb-2">
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[3]?.subTitle : null}
                                    {/* Measurable Outcomes */}
                                </h4>
                                <p>
                                    {PartnerPagePartnerWithOnex ? PartnerPagePartnerWithOnex[3]?.description : null}
                                    {/* Track the real impact of your contributions through success stories, impact reports, and growth metrics. */}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Right Side Vertical Image */}
                    <div className="w-full lg:w-1/3 flex justify-center items-stretch">
                        <img
                            src={PartnerPagePartnerWithOnex && PartnerPagePartnerWithOnex[0]?.src
                                ? PartnerPagePartnerWithOnex[0].src
                                : image}
                            alt="Partner Visual"
                            className="rounded-lg shadow-lg object-cover h-[520px] w-full max-w-sm"
                        />
                    </div>

                </div>
            </div>




        </div>
    );
}
